import React, { useContext, useEffect } from 'react';
import { Mode } from './constants'
import { useMIDI } from './contexts/MIDIContext';
import { WebRTCContext } from './contexts/WebRTCContext';

const MIDIControlPanel = ({ mode = Mode.LOCAL, showInput = true, showOutput = true }) => {
    const {
        midiAccess,
        midiInputs,
        midiOutputs,
        selectedInput,
        selectedOutput,
        midiInputChannel,
        midiOutputChannel,
        setSelectedInput,
        setSelectedOutput,
        setMidiInputChannel,
        setMidiOutputChannel,
        requestMIDIAccess,
        sendRawMIDI,
        registerOnMidiMessageReceivedCallback,
    } = useMIDI();

    const { registerDataChannelCallback, sendData } = useContext(WebRTCContext);

    // Dropdown options for channels (1-16)
    const channelOptions = Array.from({ length: 16 }, (_, i) => i + 1);

    const handleEnableMIDI = async () => {
        const success = await requestMIDIAccess();
        if (success) {
            if (mode === Mode.LOCAL) {
                registerDataChannelCallback((data) => {
                    sendRawMIDI(new Uint8Array(data));
                });
            } else if (mode === Mode.REMOTE) {
                registerOnMidiMessageReceivedCallback((event) => {
                    sendData(event.data);
                });
            }
        } else {
          console.log("handleEnableMIDI - MIDI access failed.");
        }
      };

    useEffect(() => {
        // Register a callback to process incoming data from the data channel.
        // Data arrives from the WebRTC Connection, this function gets called,
        // we forward the data to sendRawMIDI(), which executes on the 'local' side
        registerDataChannelCallback((data) => {
            sendRawMIDI(new Uint8Array(data));
        });
    }, [selectedOutput]);

    return (
        <div style={{ padding: '10px', backgroundColor: '#cfcfcf', border: '1px solid #ccc', margin: '1rem' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '10px' }}>MIDI Configuration</h2>
            {!midiAccess ? (
                <button
                    onClick={handleEnableMIDI}
                    style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                >
                    Enable MIDI
                </button>
            ) : (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '30px', flexWrap: 'wrap' }}>
                    {showInput && (
                        <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff' }}>
                            <label style={{ fontWeight: 'bold', marginRight: '10px' }}>MIDI Input:</label>
                            <select
                                value={selectedInput ? selectedInput.id : ''}
                                onChange={(e) => {
                                    const input = midiInputs.find((i) => i.id === e.target.value);
                                    setSelectedInput(input);
                                }}
                                style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', marginRight: '10px' }}
                            >
                                {midiInputs.map((input) => (
                                    <option key={input.id} value={input.id}>
                                        {input.name}
                                    </option>
                                ))}
                            </select>
                            
                            <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Channel:</label>
                            <select
                                value={midiInputChannel}
                                onChange={(e) => setMidiInputChannel(Number(e.target.value))}
                                style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                            >
                                {channelOptions.map((channel) => (
                                    <option key={channel} value={channel}>
                                        {channel}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    {showOutput && (
                        <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff' }}>
                            <label style={{ fontWeight: 'bold', marginRight: '10px' }}>MIDI Output:</label>
                            <select
                                value={selectedOutput ? selectedOutput.id : ''}
                                onChange={(e) => {
                                    const output = midiOutputs.find((o) => o.id === e.target.value);
                                    setSelectedOutput(output);
                                }}
                                style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', marginRight: '10px' }}
                            >
                                {midiOutputs.map((output) => (
                                    <option key={output.id} value={output.id}>
                                        {output.name}
                                    </option>
                                ))}
                            </select>
                            
                            <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Channel:</label>
                            <select
                                value={midiOutputChannel}
                                onChange={(e) => setMidiOutputChannel(Number(e.target.value))}
                                style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                            >
                                {channelOptions.map((channel) => (
                                    <option key={channel} value={channel}>
                                        {channel}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MIDIControlPanel;